import { html } from '@shared/utils/rendering/html';
import { createContext } from 'preact';
import { useContext, useState, useCallback } from 'preact/hooks';

const CacheContext = createContext();

export function CacheProvider({ children }) {
    const [cacheKeys, setCacheKeys] = useState({});

    const setKey = (name, value) => {
        if (name && value) {
            setCacheKeys({
                ...cacheKeys,
                [name]: value,
            });
        }
    };

    const getKey = (name) => {
        if (name) {
            return cacheKeys[name];
        }
        return '';
    };

    return html`
        <${CacheContext.Provider}
            value=${{
                setKey,
                getKey,
            }}
        >
            ${children}
        </${CacheContext.Provider}>
    `;
}

export function useCache() {
    return useContext(CacheContext);
}
